// lang/questionnaireData.js
// 语言常量
export const LANGUAGES = {
  ES: 'es',
  EN: 'en',
  DE: 'de'
};

// 多语言问卷数据
export const itemListData = {
  en: [
    {
      'Question ID': 1,
      Question: 'Seleccionar el almacenamiento',
      'Multiple choice': 'no'
    }
  ],
  es: [
    {
      'Question ID': 1,
      Question: 'Seleccionar el almacenamiento',
      'Multiple choice': 'no'
    }
  ],
  de: [
    {
      'Question ID': 1,
      Question: 'Speicher auswählen',
      'Multiple choice': 'no'
    }
  ]
};

// 多语言问卷数据
export const questionnaireData = {
  // 英语版本（默认）
  en: [
    {
      'Question ID': 30,
      Question: 'Is the device severely damaged or unable to power on properly?',
      'Multiple choice': 'no'
    },
    {
      'Question ID': 29,
      Question: 'Test',
      'Multiple choice': 'yes'
    },
    {
      'Question ID': 28,
      Question: 'Does the device charge properly and does the battery provide good autonomy?',
      'Multiple choice': 'no'
    },
    {
      'Question ID': 27,
      Question: 'Is the battery health above 85% according to Settings > Battery > Health?',
      'Multiple choice': 'no'
    },
    {
      'Question ID': 26,
      Question:
        'Do all functions operate properly (camera, sound, buttons, charging, Wi-Fi/Bluetooth, Face ID/Touch)?',
      'Multiple choice': 'no'
    },
    {
      'Question ID': 25,
      Question: 'Is the casing in good condition, without dents, bumps, cracks, or deformation?',
      'Multiple choice': 'no'
    },
    {
      'Question ID': 24,
      Question: 'Is the screen intact, without cracks, stains, or touch issues?',
      'Multiple choice': 'no'
    },
    {
      'Question ID': 23,
      Question: 'Does the phone NOT have major damage (broken back, bent frame)?',
      'Multiple choice': 'no'
    },
    {
      'Question ID': 5,
      Question:
        'Is the battery health ABOVE 85% and in optimal condition (Settings > Battery > Health)?',
      'Multiple choice': 'no'
    },
    {
      'Question ID': 4,
      Question:
        'Does the phone NOT have major functional or structural damage (functional failure, broken back)?',
      'Multiple choice': 'no'
    },
    {
      'Question ID': 3,
      Question: 'Does the phone only show acceptable LIGHT wear (minor signs of normal use)?',
      'Multiple choice': 'no'
    },
    {
      'Question ID': 2,
      Question: 'Is the screen completely intact, without cracks, stains, or visible defects?',
      'Multiple choice': 'no'
    },
    {
      'Question ID': 1,
      Question: 'Can the device be powered on and used without any locks (PIN, Google, or iCloud)?',
      'Multiple choice': 'no'
    },
    // 新增的英语问题需要添加对应的英文翻译
    {
      'Question ID': 37,
      Question:
        'Is the battery health ABOVE 80% and in optimal condition (Settings > Battery > Health)?',
      'Multiple choice': 'no'
    },
    {
      'Question ID': 36,
      Question: 'Is the device in good aesthetic condition, without damage (dents or cracks)?',
      'Multiple choice': 'no'
    },
    {
      'Question ID': 35,
      Question:
        'Does the screen work properly (no stains, double image, dead pixels, or touch issues)?',
      'Multiple choice': 'no'
    },
    {
      'Question ID': 33,
      Question:
        'Is the device condition acceptable (no breakage or deformation, and no functional failures)?',
      'Multiple choice': 'no'
    },
    {
      'Question ID': 32,
      Question:
        'Is the device unlocked and free from accounts (SIM, screen, Google, iCloud, etc.)?',
      'Multiple choice': 'no'
    }
  ],

  // 西班牙语版本
  es: [
    {
      'Question ID': 37,
      Question:
        '¿La batería tiene una salud SUPERIOR al 80 %, en estado óptimo (Ajustes > Batería > Salud)?',
      'Multiple choice': 'no'
    },
    {
      'Question ID': 36,
      Question: '¿El dispositivo está en buen estado estético, sin daños (golpes o grietas)?',
      'Multiple choice': 'no'
    },
    {
      'Question ID': 35,
      Question:
        '¿La pantalla funciona correctamente (sin manchas, doble imagen, píxeles muertos o fallos táctiles)?',
      'Multiple choice': 'no'
    },
    {
      'Question ID': 33,
      Question:
        '¿El estado del dispositivo es aceptable (sin rotura o deformación, y sin fallos de funcionamiento)?',
      'Multiple choice': 'no'
    },
    {
      'Question ID': 32,
      Question:
        '¿El dispositivo está desbloqueado y sin cuentas (SIM, pantalla, Google, iCloud, etc.)?',
      'Multiple choice': 'no'
    },
    {
      'Question ID': 30,
      Question:
        'El dispositivo está en estado estético perfecto (sin arañazos, golpes ni signos visibles de uso)',
      'Multiple choice': 'no'
    },
    {
      'Question ID': 29,
      Question: 'test',
      'Multiple choice': 'yes'
    },
    {
      'Question ID': 28,
      Question: '¿El dispositivo se carga bien y la batería mantiene buena autonomía?',
      'Multiple choice': 'no'
    },
    {
      'Question ID': 27,
      Question: '¿La batería mantiene más del 85 % de salud según Ajustes > Batería > Salud?',
      'Multiple choice': 'no'
    },
    {
      'Question ID': 26,
      Question:
        '¿Todas las funciones operan bien (cámara, sonido, botones, carga, Wi-Fi/Bluetooth, Face ID/Touch)?',
      'Multiple choice': 'no'
    },
    {
      'Question ID': 25,
      Question:
        '¿La carcasa está en buen estado, sin golpes, abolladuras, grietas o deformaciones?',
      'Multiple choice': 'no'
    },
    {
      'Question ID': 24,
      Question: '¿La pantalla está intacta, sin grietas, manchas o fallos táctiles?',
      'Multiple choice': 'no'
    },
    {
      'Question ID': 23,
      Question: '¿El móvil NO tiene roturas graves (trasera rota, chasis doblado)?',
      'Multiple choice': 'no'
    },
    {
      'Question ID': 5,
      Question:
        '¿La batería tiene una salud SUPERIOR al 85 %, en estado óptimo (Ajustes > Batería > Salud)?',
      'Multiple choice': 'no'
    },
    {
      'Question ID': 4,
      Question:
        '¿El móvil NO presenta daños graves de funcionamiento o estructura (fallo funcional, trasera rota)?',
      'Multiple choice': 'no'
    },
    {
      'Question ID': 3,
      Question:
        '¿El móvil solo presenta desgaste LEVE aceptable (pequeñas marcas normales de uso)?',
      'Multiple choice': 'no'
    },
    {
      'Question ID': 2,
      Question: '¿La pantalla está totalmente intacta, sin grietas, manchas ni defectos visibles?',
      'Multiple choice': 'no'
    },
    {
      'Question ID': 1,
      Question: '¿Se puede encender y usar sin bloqueos (PIN, Google o iCloud)?',
      'Multiple choice': 'no'
    }
  ],

  // 德语版本
  de: [
    {
      'Question ID': 37,
      Question:
        'Hat der Akku einen Zustand von über 80 % und ist in optimalem Zustand (Einstellungen > Batterie > Batteriezustand)?',
      'Multiple choice': 'no'
    },
    {
      'Question ID': 36,
      Question: 'Ist das Gerät in gutem optischen Zustand, ohne Schäden (starke Stöße oder Risse)?',
      'Multiple choice': 'no'
    },
    {
      'Question ID': 35,
      Question:
        'Funktioniert der Bildschirm einwandfrei (keine Flecken, Doppelbilder, Pixelfehler oder Touch-Probleme)?',
      'Multiple choice': 'no'
    },
    {
      'Question ID': 33,
      Question:
        'Ist der Zustand des Geräts akzeptabel (keine Verformungen oder Schäden und keine Funktionsfehler)?',
      'Multiple choice': 'no'
    },
    {
      'Question ID': 32,
      Question:
        'Ist das Gerät entsperrt und frei von Konten (SIM, Bildschirm, Google, iCloud usw.)?',
      'Multiple choice': 'no'
    },
    {
      'Question ID': 30,
      Question:
        'Ist das Gerät in perfektem optischen Zustand (keine Kratzer, Stöße oder sichtbare Gebrauchsspuren)?',
      'Multiple choice': 'no'
    },
    {
      'Question ID': 29,
      Question: 'Test',
      'Multiple choice': 'yes'
    },
    {
      'Question ID': 28,
      Question: 'Lässt das Gerät gut und hat der Akku eine gute Laufzeit?',
      'Multiple choice': 'no'
    },
    {
      'Question ID': 27,
      Question: 'Liegt die Batteriezustand über 85 % laut Einstellungen > Batterie > Zustand?',
      'Multiple choice': 'no'
    },
    {
      'Question ID': 26,
      Question:
        'Funktionieren alle Funktionen einwandfrei (Kamera, Ton, Tasten, Laden, Wi-Fi/Bluetooth, Face ID/Touch)?',
      'Multiple choice': 'no'
    },
    {
      'Question ID': 25,
      Question: 'Ist das Gehäuse in gutem Zustand, ohne Stöße, Dellen, Risse oder Verformungen?',
      'Multiple choice': 'no'
    },
    {
      'Question ID': 24,
      Question: 'Ist der Bildschirm intakt, ohne Risse, Flecken oder Touchprobleme?',
      'Multiple choice': 'no'
    },
    {
      'Question ID': 23,
      Question: 'Hat das Gerät KEINE schweren Schäden (gebrochene Rückseite, verbogenes Gehäuse)?',
      'Multiple choice': 'no'
    },
    {
      'Question ID': 5,
      Question:
        'Liegt die Batteriezustand ÜBER 85 % und ist in optimalem Zustand (Einstellungen > Batterie > Zustand)?',
      'Multiple choice': 'no'
    },
    {
      'Question ID': 4,
      Question:
        'Weist das Gerät KEINE schwerwiegenden Funktions- oder Strukturschäden auf (Funktionsfehler, gebrochene Rückseite)?',
      'Multiple choice': 'no'
    },
    {
      'Question ID': 3,
      Question:
        'Weist das Gerät nur LEICHTE, akzeptable Gebrauchsspuren auf (kleine, normale Nutzungsspuren)?',
      'Multiple choice': 'no'
    },
    {
      'Question ID': 2,
      Question: 'Ist der Bildschirm vollständig intakt, ohne Risse, Flecken oder sichtbare Mängel?',
      'Multiple choice': 'no'
    },
    {
      'Question ID': 1,
      Question:
        'Lässt sich das Gerät einschalten und ohne Sperren nutzen (PIN, Google oder iCloud)?',
      'Multiple choice': 'no'
    }
  ]
};

// 语言名称映射（用于显示）
export const languageNames = {
  [LANGUAGES.ENGLISH]: 'English',
  [LANGUAGES.SPANISH]: 'Español',
  [LANGUAGES.GERMAN]: 'Deutsch'
};

/**
 * 根据指定语言获取问卷数据
 * @param {string} lang - 语言代码 ('es' | 'en' | 'de')
 * @returns {Array} 问卷数据数组
 */
export function getQuestionnaireByLang(lang) {
  if (!lang) {
    lang = 'es';
  }


  lang = lang.toLowerCase();

  console.log('getQuestionnaireByLang', lang)

  console.log(questionnaireData[lang])

  return questionnaireData[lang] || questionnaireData[LANGUAGES.SPANISH] || [];
}

export function getSkuQuestionnaireByLang(lang) {
  if (!lang) {
    lang = 'es';
  }

  lang = lang.toLowerCase();

  return itemListData[lang] || itemListData[LANGUAGES.SPANISH] || [];
}

/**
 * 获取问题文本映射（Question ID -> Question）
 * @param {string} lang - 语言代码
 * @returns {Map} 问题 ID 到问题文本的映射
 */
export function getQuestionMap(lang) {
  const data = getQuestionnaireByLang(lang);
  return new Map(data.map(item => [item['Question ID'], item['Question']]));
}

/**
 * 获取答案文本映射（Answer ID -> Answer Text）
 * @returns {Map} 答案 ID 到答案文本的映射
 */
export function getAnswerTextMap() {
  return answerIdMap;
}

/**
 * 根据问题 ID 获取问题文本
 * @param {number} questionId - 问题 ID
 * @param {string} originalName - 原始名称（用于未匹配时返回）
 * @param {Map} questionMap - 问题映射表
 * @returns {string} 问题文本
 */
export function getQuestionTextById(questionId, originalName, questionMap) {
  if (questionMap.has(questionId)) {
    return questionMap.get(questionId);
  }
  return originalName;
}

/**
 * 根据答案 ID 获取答案文本
 * @param {string} answerId - 答案 ID
 * @param {string} originalValue - 原始值（用于未匹配时返回）
 * @param {Map} answerMap - 答案映射表
 * @returns {string} 答案文本
 */
export function getAnswerTextById(answerId, originalValue, answerMap) {
  const id = parseInt(answerId, 10);
  if (answerMap.has(id)) {
    return answerMap.get(id);
  }
  return originalValue;
}

// // 答案 ID 到答案文本的映射（Yes/No 类型）
// export const answerIdMap = new Map([
//   [1, 'Sí'],
//   [3, 'Sí'],
//   [5, 'Sí'],
//   [7, 'Sí'],
//   [9, 'Sí'],
//   [8, 'No'],
//   [55, 'Sí'],
//   [56, 'No'],
//   [58, 'Sí'],
//   [59, 'No'],
//   [60, 'Sí'],
//   [61, 'No'],
//   [62, 'Sí'],
//   [63, 'No'],
//   [64, 'Sí'],
//   [65, 'No'],
//   [66, 'Sí'],
//   [67, 'No'],
//   [68, 'Sí'],
//   [69, 'No']
// ]);

// 多语言答案映射
const answerIdMapByLang = {
  es: new Map([
    [1, 'Sí'],
    [3, 'Sí'],
    [5, 'Sí'],
    [7, 'Sí'],
    [9, 'Sí'],
    [8, 'No'],
    [55, 'Sí'],
    [56, 'No'],
    [58, 'Sí'],
    [59, 'No'],
    [60, 'Sí'],
    [61, 'No'],
    [62, 'Sí'],
    [63, 'No'],
    [64, 'Sí'],
    [65, 'No'],
    [66, 'Sí'],
    [67, 'No'],
    [68, 'Sí'],
    [69, 'No']
  ]),
  en: new Map([
    [1, 'Yes'],
    [3, 'Yes'],
    [5, 'Yes'],
    [7, 'Yes'],
    [9, 'Yes'],
    [8, 'No'],
    [55, 'Yes'],
    [56, 'No'],
    [58, 'Yes'],
    [59, 'No'],
    [60, 'Yes'],
    [61, 'No'],
    [62, 'Yes'],
    [63, 'No'],
    [64, 'Yes'],
    [65, 'No'],
    [66, 'Yes'],
    [67, 'No'],
    [68, 'Yes'],
    [69, 'No']
  ]),
  de: new Map([
    [1, 'Ja'],
    [3, 'Ja'],
    [5, 'Ja'],
    [7, 'Ja'],
    [9, 'Ja'],
    [8, 'Nein'],
    [55, 'Ja'],
    [56, 'Nein'],
    [58, 'Ja'],
    [59, 'Nein'],
    [60, 'Ja'],
    [61, 'Nein'],
    [62, 'Ja'],
    [63, 'Nein'],
    [64, 'Ja'],
    [65, 'Nein'],
    [66, 'Ja'],
    [67, 'Nein'],
    [68, 'Ja'],
    [69, 'Nein']
  ])
};

/**
 * 获取答案映射
 * @returns {Map} 答案 ID 到答案文本的映射
 */
export function getAnswerIdMap() {
  return answerIdMap;
}


/**
 * 根据语言获取答案 ID 到答案文本的映射
 * @param {string} lang - 语言代码 ('es' | 'en' | 'de')
 * @returns {Map} 答案 ID 到答案文本的映射
 */
export function getAnswerIdMapByLang(lang) {
  if (!lang) {
    lang = 'es';
  }

  lang = lang.toLowerCase();

  console.log('getAnswerIdMapByLang', lang)

  return answerIdMapByLang[lang] || answerIdMapByLang[LANGUAGES.SPANISH] || answerIdMapByLang[LANGUAGES.ENGLISH];
}
